import { WalletInterface } from '@api';

import { ConnectedWallet } from './ConnectedWallet/ConnectedWallet';
import { ConnectWallet } from './ConnectWallet/ConnectWallet';
import { getConnectedWallet } from './model/getConnectedWallet';
import { useAvailableConnectTypes } from './model/useAvailableConnectTypes';

interface WalletsInfoCardProps {
  wallets: WalletInterface[];
  withActionButtons?: boolean;
  withConnectWallet?: boolean;
}

export const WalletsList = ({
  wallets,
  withActionButtons = true,
  withConnectWallet = true,
}: WalletsInfoCardProps) => {
  const { connectTypes } = useAvailableConnectTypes(wallets);

  return (
    <div className="flex flex-col gap-5">
      {connectTypes.map((type) => {
        const walletInfo = getConnectedWallet(wallets, type);
        return (
          <div key={type} className="flex flex-col gap-4">
            {walletInfo ? (
              <ConnectedWallet
                withActionButtons={withActionButtons}
                walletInfo={walletInfo}
                connectType={type}
              />
            ) : (
              <>{withConnectWallet && <ConnectWallet connectType={type} />}</>
            )}
          </div>
        );
      })}
    </div>
  );
};
